module.exports = __webpack_public_path__ + "static/media/login.3a875a16.svg";